export default __webpack_public_path__ + "static/media/database.ee6afc06.png";